<mat-sidenav-container class="sidenav-container">
  <mat-sidenav *ngIf="!isOnboarding || isFdUser" #sidenav mode="side" opened class="sidenav-menu"
    [class.menu-open]="isExpanded" [class.menu-close]="!isExpanded" [fixedInViewport]="options.value.fixed"
    [fixedTopGap]="options.value.top" [fixedBottomGap]="options.value.bottom"
    [ngStyle]="{ 'width.px': width, 'transition': transition }">
    <mat-nav-list role="navigation">
      <div>
        <div class="toggle-container cursor-pointer">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" [class.close-toggle]="isPinned"
            (click)="toggleMenu()">
            <path
              d="M5.71 6.70001C5.32 7.09001 5.32 7.72001 5.71 8.11001L9.58 12L5.7 15.88C5.51303 16.067 5.40798 16.3206 5.40798 16.585C5.40798 16.8494 5.51303 17.103 5.7 17.29C5.88698 17.477 6.14058 17.582 6.405 17.582C6.66943 17.582 6.92303 17.477 7.11 17.29L11.7 12.7C11.7927 12.6075 11.8663 12.4976 11.9164 12.3766C11.9666 12.2557 11.9924 12.126 11.9924 11.995C11.9924 11.864 11.9666 11.7344 11.9164 11.6134C11.8663 11.4924 11.7927 11.3825 11.7 11.29L7.12 6.70001C7.02749 6.6073 6.9176 6.53375 6.79663 6.48357C6.67565 6.43339 6.54597 6.40756 6.415 6.40756C6.28404 6.40756 6.15435 6.43339 6.03338 6.48357C5.9124 6.53375 5.80252 6.6073 5.71 6.70001Z"
              fill="#FCC11A" />
            <path
              d="M12.3 6.70001C11.91 7.09001 11.91 7.72001 12.3 8.11001L16.17 12L12.29 15.88C12.103 16.067 11.998 16.3206 11.998 16.585C11.998 16.8494 12.103 17.103 12.29 17.29C12.477 17.477 12.7306 17.582 12.995 17.582C13.2594 17.582 13.513 17.477 13.7 17.29L18.29 12.7C18.3827 12.6075 18.4562 12.4976 18.5064 12.3766C18.5566 12.2557 18.5824 12.126 18.5824 11.995C18.5824 11.864 18.5566 11.7344 18.5064 11.6134C18.4562 11.4924 18.3827 11.3825 18.29 11.29L13.71 6.70001C13.6175 6.6073 13.5076 6.53375 13.3866 6.48357C13.2657 6.43339 13.136 6.40756 13.005 6.40756C12.874 6.40756 12.7443 6.43339 12.6234 6.48357C12.5024 6.53375 12.3925 6.6073 12.3 6.70001Z"
              fill="#FCC11A" />
          </svg>
        </div>
        <img class="close-logo" *ngIf="!isExpanded" src="assets/images/Fraud Deflect_logo_simple.png" />
        <img [ngClass]="isExpanded && !isDarkMode ? 'open-logo display-block' : 'open-logo display-none'"
          src="assets/images/Fraud_Deflect_logo2-removebg.png" />
        <img [ngClass]="isExpanded && isDarkMode ? 'open-logo display-block' : 'open-logo display-none'"
          src="assets/images/Fraud_Deflect_logo2-removebg.png" />
        <div class="sidebar-container">
          @for(menuItem of menuList; track menuItem){
          @if((menuItem.subMenu?.length ?? 0) > 0){
          <div mat-list-items>
            <mat-expansion-panel [hideToggle]="false">
              <mat-expansion-panel-header class="side-menu-link" (click)="expandMenu()" [ngClass]="
              !externalMenu && (
              (dataTableSelected && menuItem.name == 'Tables') ||
              (dataQueueSelected && menuItem.name == 'Queue') ||
              (dataAdminSelected && menuItem.name == 'Admin')  ||
              (dataTitanSelected && menuItem.name == 'Titan')  ||
              (dataToolsSelected && menuItem.name == 'Tools')  ||
              (dataFdIdSelected && (menuItem.name == 'FDID' || menuItem.name == 'FD.ID')) ||
              (dataOnboardingSelected && menuItem.name == 'Onboarding')
            )
              ? 'has-sub-menu-selected'
              : ''
            ">
                <mat-panel-title [ngClass]="
                !externalMenu && (
                  (dataTableSelected && menuItem.name == 'Tables') ||
                  (dataQueueSelected && menuItem.name == 'Queue') ||
                  (dataAdminSelected && menuItem.name == 'Admin')  ||
                  (dataTitanSelected && menuItem.name == 'Titan')  ||
                  (dataToolsSelected && menuItem.name == 'Tools')  ||
                  (dataFdIdSelected && (menuItem.name == 'FDID' || menuItem.name == 'FD.ID')) ||
                  (dataOnboardingSelected && menuItem.name == 'Onboarding')
                )
                  ? 'manual-highlight'
                  : ''
                ">
                  <mat-icon>{{ menuItem.icon }}</mat-icon>
                  <span class="menu-text" *ngIf="isExpanded">{{ menuItem.name }}</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="sub-menu-container" *ngIf="isExpanded">
                @for(item of (menuItem.subMenu || []); track item){
                <a mat-list-item class="sub-menu-link" [class.sub-menu-close]="!isExpanded" [routerLink]="item.url"
                  routerLinkActive="active-menu-item" [routerLinkActiveOptions]="{ exact: true }">
                  <mat-icon>{{ item.icon }}</mat-icon>
                  <span class="menu-text">{{ item.name }}</span>
                </a>
                }
              </div>
            </mat-expansion-panel>
          </div>
          } @else {
          <a mat-list-item class="side-menu-link no-sub-menu" [routerLink]="menuItem.url" (click)="expandMenu()"
            routerLinkActive="active-menu-item" [routerLinkActiveOptions]="{ exact: true }"
            [class.dashboard-item]="menuItem.name == 'Dashboard'">
            @if( ['user-class','users','merchant-groups'].indexOf(menuItem.url)
            > - 1 ){
            <mat-icon class="svgIcon" svgIcon="{{ menuItem.icon }}"></mat-icon>
            <span class="menu-text" *ngIf="isExpanded">{{ menuItem.name }}</span>
            } @else {
            <mat-icon>{{ menuItem.icon }}</mat-icon>
            <span class="menu-text" *ngIf="isExpanded">{{ menuItem.name }}</span>
            }
          </a>
          } }
        </div>
      </div>
    </mat-nav-list>
    <app-theme-selector *ngIf="isExpanded" (themeSelected)="themeSelected($event)"></app-theme-selector>
  </mat-sidenav>
  <mat-sidenav-content [ngStyle]="{ 'margin-left.px': contentMargin }">
    <app-breadcrumbs></app-breadcrumbs>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>